import { DataGrid } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import { UserDataSources } from 'app/containers/UserAdmin/Datasource';
import * as React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { AdminAction } from '../../redux/Admin/actions';
import { IUserState } from '../../redux/Admin/reducer';

interface IUser {
    email: string
    firstname: string
    lastname: string
    username: string
}

interface IContainerState {
    showModal: boolean
    user?: any
    selectedUser: IUserState
    admin?: any
}

class UserAdmin extends Container<{}, IContainerState> {
    state = {
        showModal: false,
        selectedUser: undefined,
        admin: undefined
    }

    mapAppStateToContainerState(appState: IAppState): IContainerState {
        const { showModal, selectedUser } = this.state
        return { user: appState.User, admin: appState.User, showModal, selectedUser }
    }

    prepareExport(): any {
        const rows = [['Username', 'First Name', 'Last Name', 'Email']]

        UserDataSources.onSync((data) => {
            data.forEach((i) => {
                rows.push([i.username, i.firstname, i.lastname, i.email])
            })
            const csvContent = rows.map((u) => u.join(',')).join('\n')

            const blob = new Blob([csvContent], { type: 'data:text/csv;charset=utf-8;' })
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, 'userList.csv');
            } else {
                const link = document.createElement('a');
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', 'userList.csv');
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        })
        UserDataSources.setStartIndexAndSize(0, 1000).sync()
    }

    renderTrashButton(row: IUserState): any {
        return (
            <Button bsStyle="danger" bsSize="small" onClick={() => {
                this.setState({ selectedUser: row, showModal: true })
            }}>
                <i className="fa fa-trash" />
            </Button>
        )
    }

    closeModal(): any {
        this.setState({ showModal: false, selectedUser: undefined })
    }

    renderDeleteUserModal(): any {
        return (
            <Modal show={this.state.showModal} onHide={() => this.closeModal()}>
                <Modal.Header closeButton onClick={() => this.closeModal()}>
                    <Modal.Title>Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please confirm that you would like to delete
                        user: <strong>{this.state.selectedUser ? this.state.selectedUser.username : ''}</strong></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" bsSize="small" className="pull-right"
                        onClick={() => this.deleteUser()}>Delete User</Button>
                    <Button bsStyle="info" bsSize="small" className="pull-right margin-right"
                        onClick={() => this.closeModal()}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    deleteUser(): any {
        AdminAction.deleteUser(
            this.state.selectedUser.username,
            this.state.selectedUser.firstname,
            this.state.selectedUser.lastname,
            this.state.selectedUser.email,
            this.state.admin.token,
            this.state.admin.accessToken,
        )
            .then(() => {
                // todo: update datagrid on user deletion
                // tslint:disable-next-line:no-console
                console.log('user deleted')
                this.closeModal()
                window.location.reload();
            }, (error) => {
                // tslint:disable-next-line:no-console
                console.log(error)
            })
            .catch()
    }

    render() {
        return (
            <section>
                <section className="container padding-top-lg">
                    <Row>
                        <Col md={6} className="margin-y-sm">
                            <h3 style={{ marginTop: 0 }}>User Administration</h3>
                        </Col>
                        <Col md={6} className="margin-y-sm ">
                            <Button bsStyle="danger" bsSize="small" className="pull-right" href="#/useradd">Add
                                User</Button>
                            <Button bsStyle="info" bsSize="small" className="pull-right margin-right"
                                onClick={() => this.prepareExport()}>Download Table</Button>
                        </Col>
                    </Row>
                    <Row>
                        <DataGrid DataSource={UserDataSources}
                            pageSizes={[20, 50, 100]}
                            columns={[
                                { label: 'Username', pathExpression: '$.username' },
                                { label: 'First Name', pathExpression: '$.firstname' },
                                { label: 'Last Name', pathExpression: '$.lastname' },
                                { label: 'Email', pathExpression: '$.email' },
                                {
                                    label: 'Delete User',
                                    pathExpression: '$.email',
                                    customRender: (row) => this.renderTrashButton(row)
                                },
                            ]}
                        />
                    </Row>
                </section>
                {this.renderDeleteUserModal()}
            </section>
        )
    }
}

export {
    UserAdmin
}



// WEBPACK FOOTER //
// ./src/app/containers/UserAdmin/index.tsx